// extracted by mini-css-extract-plugin
export var container = "_7o-0";
export var fallback = "_7o-5";
export var fallbackIcon = "_7o-6";
export var hidden = "_7o-2";
export var image = "_7o-3";
export var loaded = "_7o-4";
export var placeholder = "_7o-1";